<template>
  <div class="partner-manager-template" theme>
    <div id="partner-manager-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'manager/partner',
      parts: [
        {
          elem: '#partner-manager-content',
          htmlFile: 'list'
        }
      ]
    }
  }
}
</script>
